import React, {Component} from 'react'
import {Button} from "react-bootstrap";
import * as axios from "axios";
import Zgody from "../../shared/Zgody";
import {NotificationManager} from "react-notifications";

export default class AplikacjaMobilna extends Component {

    constructor(props) {
        super(props);

        this.state = {
            registerMail: '',
            warunki: false,
            newsletter: false,
        };

        this.handleMail = this.handleMail.bind(this)
    }

    handleMail(e) {
        this.setState({registerMail: e.target.value})
    }

    onClickZapisz() {

        let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(this.state.registerMail) === false) {
            NotificationManager.error("", "Nieprawidłowy adres e-mail ", 5000);
        } else {
            if (!this.state.warunki || !this.state.newsletter) {
                NotificationManager.error("", "Aby zapisać się do newslettera należy zaakceptować warunki ", 5000);
            } else {
                axios({
                    method: 'GET',
                    url: "https://api-mailing.marcel-bus.pl/api/public/subscriber/register?email=" + this.state.registerMail,
                    headers: {
                        'Authorization': 'Basic dG9wc2E6cGFzcw==',
                        'Content-Type': 'application/json'
                    }
                }).then(response => {
                    if (response.status === 200) {
                        NotificationManager.success("", "Adres " + this.state.registerMail + " został pomyślnie zapisany do newslettera ", 5000);
                        this.setState({registerMail: '', zgoda: false})
                    }
                }).catch(error => {
                    console.log(error);
                });
            }
        }

    }

    render() {
        return (
            <div className="newsletter">

                <div className="row mobilkaFixRow" style={{fontSize: '0.875rem'}}>
                    <div className="col-lg-3"></div>
                    <div className="col-lg-4 text-center paddingNewsletter" style={{paddingTop: 75, paddingBottom: 25}}>
                        <h2 style={{fontWeight: 'bold'}}>Zapisz się do naszego newslettera</h2>
                        <p>Dowiaduj się o naszych specjalnych ofertach i promocjach jako pierwszy!</p>
                        <div className="text-center"><input type="mail" value={this.state.registerMail}
                                                            onChange={this.handleMail} className="form-control"
                                                            placeholder={'Twój adres e-mail'}
                                                            style={{width: '90%', marginLeft: 25}}/></div>

                        <div style={{marginTop: 15}} className="text-left">
                            <Zgody war1={true} war2={true} newsletter={this.state.newsletter}
                                   warunki={this.state.warunki}
                                   setNewsletter={() => this.setState({newsletter: !this.state.newsletter})}
                                   setWarunki={() => this.setState({warunki: !this.state.warunki})}/>
                        </div>
                        <div><Button bsStyle={'success'} onClick={() => this.onClickZapisz()}
                                     className="zapiszNewsletterBtn" style={{
                            paddingLeft: 25,
                            paddingRight: 25,
                            marginTop: 15,
                            marginBottom: 15
                        }}>Zarejestruj</Button></div>
                        <p style={{fontSize: '0.75rem'}}>W każdej chwili możesz anulować subskrypcję przez przycisk
                            znajdujący się w stopce wiadomości e-mail.</p>
                    </div>
                    <div className="col-lg-2 text-center flexbox">
                        <i className="fa fa-envelope-open-o" style={{fontSize: '15em', color: '#8dc846'}}> </i>
                    </div>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/Newsletter.js